import { useEffect, useRef } from 'react';

interface ScrollToHashOptions {
  hash: string;
  offset: number;
}

const useScrollToHash = ({ hash, offset }: ScrollToHashOptions) => {
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (window.location.hash === hash && elementRef.current) {
      const scrollTopDistance = elementRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: scrollTopDistance - offset,
        behavior: 'smooth',
      });
    }
  }, [hash, offset]); // Dependencies to allow re-running if needed

  return elementRef;
};

export default useScrollToHash;
